import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {
    ProductInfo2({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Product/Info2',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    ProductInfo({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Product/Info',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    ProductWebList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Product/WebList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js